// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3Zz5-","dragIcon":"SortableItem_dragIcon__XYJJj","disabled":"SortableItem_disabled__1bFna"};